import { LitElement, html, svg } from 'lit';

export class IconChevronDoubleLeft16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 13 2 8l5-5M14 13 9 8l5-5"></path></svg>`; }
}
if (!customElements.get('f-icon-chevron-double-left16', IconChevronDoubleLeft16)) {
  customElements.define('f-icon-chevron-double-left16', IconChevronDoubleLeft16);
}